var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconKe = function SvgIconKe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 0A12 12 0 0 0 1.192 6.781H22.81A12 12 0 0 0 12-.001"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#496E2D",
    d: "M12 24a12 12 0 0 1-10.809-6.782H22.81A12 12 0 0 1 12 24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2001D",
    d: "M23.433 8.347H.567A12 12 0 0 0 0 12c0 1.274.2 2.5.567 3.653h22.866A12 12 0 0 0 24 11.999c0-1.273-.2-2.5-.567-3.652"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F0F0F0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.737 5.545-1.421-.656L12 10.132 9.685 4.89l-1.421.656L11.138 12l-2.874 6.454 1.42.656L12 13.867l2.316 5.243 1.42-.656L12.863 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.966 6.163c-.55-.6-.966-.946-.966-.946s-.415.345-.965.946v11.673c.55.6.965.946.965.946s.415-.345.966-.946z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#A2001D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.392 8.402v7.196a12.6 12.6 0 0 0 1.826 2.434V5.968a12.6 12.6 0 0 0-1.826 2.434M14.608 8.403a12.6 12.6 0 0 0-1.826-2.434v12.064a12.6 12.6 0 0 0 1.826-2.434z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.608 8.4v7.197c.589-1.043 1.044-2.276 1.044-3.598s-.455-2.555-1.044-3.598M9.391 8.4v7.197c-.588-1.043-1.043-2.276-1.043-3.598S8.803 9.444 9.39 8.4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconKe;